<template>
    <div class="element-overlay-container">

        <slot />

<!--        <template v-if="elementPlaybackIcon">
            <i class="fas fa-play playback-icon" />
        </template>-->

        <element-state v-if="showElementState"
                       classes="element-state-overlay elevation-4"
                       delayed-tooltip
                       only-bottom-start-border-rounded
                       show-tooltip
                       size="small" />

        <elementIcon v-if="showElementIcon"
                     :container-classes="['element-overlay-element-icon-container elevation-4']"
                     :inner-container-classes="['element-icon-padding']">
            <size-not-matching-icon v-if="sizeNotMatching" />
        </elementIcon>
    </div>
</template>

<script>
import elementState from '../../publish/elementstate.vue'
import elementIcon from '../element-icon.vue'
import { elementSizeDifferentFromLayerSize } from '../../../../../utils/publish'
import SizeNotMatchingIcon from '../sizeNotMatchingIcon.vue'

export default {
    components: { SizeNotMatchingIcon, elementIcon, elementState },
    inject: {
        /** @type {PublishInjectInfoTable} */
        publishInfoTable: {
            default: {}
        }
    },
    props: {
        /** @type {PublishElementDataCommon} */
        data: Object,
        /** @type {PublishLayer} */
        layer: Object,
        layerWidth: Number,
        layerHeight: Number,
        showElementIcon: {
            type: Boolean,
            default: true
        },
        showElementState: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        elementPlaybackIcon() {
            return this.dataComputed.type == 'video'
        },
        sizeNotMatching() {
            return elementSizeDifferentFromLayerSize(this.dataComputed.width, this.dataComputed.height, this.layerWidthComputed, this.layerHeightComputed)
        },
        dataComputed() {
            return this.data ?? this.publishInfoTable.element?.data
        },
        layerComputed() {
            return this.layer ?? this.publishInfoTable.layer
        },
        layerWidthComputed() {
            return this.layerWidth ?? this.layerComputed.width
        },
        layerHeightComputed() {
            return this.layerHeight ?? this.layerComputed.height
        }
    }
}
</script>
